import { render, staticRenderFns } from "./payroll.vue?vue&type=template&id=4c6b1a5e&scoped=true&"
import script from "./payroll.vue?vue&type=script&lang=js&"
export * from "./payroll.vue?vue&type=script&lang=js&"
import style0 from "./payroll.vue?vue&type=style&index=0&id=4c6b1a5e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b1a5e",
  null
  
)

export default component.exports